module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-twitter-black-8be9c1dfb480532d7bd2b0693f51653e.svg";